const urls = {
  home: "/",
  signIn: "/sign-in",
  signUp: "/sign-up",
  inviteAccepted: "/invite-accepted",
  settings: {
    root: "/settings",
    billing: "/settings/billing",
    profile: {
      root: "/settings/profile",
      security: "/settings/profile/security",
    },
    keywords: {
      root: "/settings/keywords",
      recommendations: "/settings/keywords/recommendations",
      options: "/settings/keywords/options",
    },
    generation: {
      root: "/settings/generation",
      brand: "/settings/generation/brand",
      featuresAndServices: "/settings/generation/features-services",
      audiences: "/settings/generation/audiences",
      website: "/settings/generation/website",
      goalPages: "/settings/generation/goal-pages",
      contentOptions: "/settings/generation/content-options",
      imageGeneration: "/settings/generation/image-generation",
      tags: "/settings/generation/tags",
    },
    team: "/settings/team",
  },
  publishing: {
    root: "/publishing",
    connections: {
      root: "/publishing/connections",
      zapier: "/publishing/connections/zapier",
      wordpress: "/publishing/connections/wordpress",
      webflow: "/publishing/connections/webflow",
      webhook: "/publishing/connections/webhook",
      shopify: "/publishing/connections/shopify",
      wix: "/publishing/connections/wix",
      framer: "/publishing/connections/framer",
    },
  },
  integrationsWordpressCallback: "/integrations/wordpress-callback",
  webflowOauthCallback: "/webflow/oauth/callback",
  articles: "/articles",
  article: (id: string) => `/articles/${id}`,
  patterns: "/patterns",
  pattern: (id: string) => `/patterns/${id}`,
  newPattern: "/patterns/new",
  lists: "/lists",
  admin: {
    root: "/admin",
    articles: "/admin/articles",
    article: (id: string) => `/admin/articles/${id}`,
    teams: "/admin/teams",
  },
  keywords: {
    root: "/keywords",
    recommendations: "/keywords/recommendations",
    searchByKeyword: "/keywords/search-by-keyword",
    searchByUrl: "/keywords/search-by-url",
    competitorGap: "/keywords/competitor-gaps",
  },
};

export default urls;
